import { BundleAddToCart } from '@/components/content/Bundle/parts/BundleAddToCart';
import { Box, Slide } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';

interface BundleAddToCartBottomProps {
	refButton: React.RefObject<HTMLDivElement>;
	refEnd: React.RefObject<HTMLDivElement>;
	refTop: React.RefObject<HTMLDivElement>;
	isReadyToAddToCart: boolean;
	onAddToCart: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => Promise<void>;
}

export const BundleAddToCartBottom = ({
	refButton,
	refEnd,
	refTop,
	isReadyToAddToCart,
	onAddToCart,
}: BundleAddToCartBottomProps) => {
	const [isVisibleEnd, setIsVisibleEnd] = useState(false);
	const [isVisibleTop, setIsVisibleTop] = useState(false);
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const updatePosition = () => {
			if (refEnd.current) {
				const rect = refEnd.current.getBoundingClientRect();
				setIsVisibleEnd(rect.y < 70);
			}
		};

		updatePosition();
		window.addEventListener('scroll', updatePosition);

		return () => {
			window.removeEventListener('scroll', updatePosition);
		};
	}, [refEnd]);

	useEffect(() => {
		const observerCallback = (entries: IntersectionObserverEntry[]) => {
			const entry = entries[0];
			setIsVisibleTop(entry.isIntersecting);
		};

		const setupObserver = () => {
			if (refTop.current) {
				const observer = new IntersectionObserver(observerCallback, { threshold: 0.1 });
				observer.observe(refTop.current);

				return () => observer.disconnect();
			} else {
				setTimeout(setupObserver, 100);
			}
		};

		setupObserver();
	}, [refTop]);

	useEffect(() => {
		const observerCallback = (entries: IntersectionObserverEntry[]) => {
			const entry = entries[0];
			setIsVisible(entry.isIntersecting);
		};

		const setupObserver = () => {
			if (refButton.current) {
				const observer = new IntersectionObserver(observerCallback, { threshold: 0.5 });
				observer.observe(refButton.current);

				return () => observer.disconnect();
			} else {
				setTimeout(setupObserver, 100);
			}
		};

		setupObserver();
	}, [refButton]);

	const shouldShowSlide = useMemo(
		() => !isVisibleTop && !isVisible && !isVisibleEnd,
		[isVisible, isVisibleEnd, isVisibleTop]
	);

	return (
		<Slide direction="up" in={shouldShowSlide}>
			<Box
				sx={{
					padding: '5px',
					width: '100vw',
					position: 'fixed',
					bottom: '0px',
					left: '0px',
					zIndex: '1001',
					backgroundColor: 'white',
				}}
			>
				<BundleAddToCart isReadyToAddToCart={isReadyToAddToCart} onAddToCart={onAddToCart} />
			</Box>
		</Slide>
	);
};
